import { useCallback } from 'react';

import { useUpdateCard } from 'apps/shared/scripts/graphql';
import { CardFragment } from 'apps/shared/scripts/graphql/fragments/CardFragment.generated';
import { useFormCallback } from 'apps/shared/scripts/hooks';

import { CardForm } from '../../components';
import { CardFormValues } from '../../components/CardForm';
import { getDefaultValues } from '../../utils';

interface Props {
  card: CardFragment;
}

const CardFormUpdateContainer = ({ card }: Props) => {
  const { mutate: updateCard, isMutating: isUpdating } = useUpdateCard({
    refetchQueries: ['Card'],
    awaitRefetchQueries: true,
  });
  const { isSuccess, onSuccess, onError } = useFormCallback({
    restoreSuccess: true,
  });

  const onSubmit = useCallback(
    async (data: CardFormValues) => {
      try {
        const { result, errors } = await updateCard({
          id: card.id,
          input: data,
        });
        if (!result || errors.length > 0) {
          throw new Error(errors[0].message);
        }
        onSuccess({ message: 'Success! Card was updated' });
      } catch (e) {
        onError(e);
        throw e;
      }
    },
    [card.id, onError, onSuccess, updateCard],
  );

  return (
    <CardForm
      isSubmitting={isUpdating}
      onSubmit={onSubmit}
      isSuccess={isSuccess}
      defaultValues={getDefaultValues(card)}
      isEditMode
    />
  );
};

CardFormUpdateContainer.displayName = 'CardFormUpdateContainer';

export default CardFormUpdateContainer;
